// extracted by mini-css-extract-plugin
module.exports = {"bar":"_1249"};